import CheckBox from "@/components/atoms/CheckBox/CheckBox";
import { PINNED_ASSET_SLUG } from "@/config/game";
import { BaseEvoPopup } from "@/pages/EvolutionsHub/Popups/BaseEvoPopup";
import { BREAKPOINTS, SKIP_RESET_EVOLUTIONS_DEFAULT_MODAL } from "@/settings";
import { Trans, useTranslation } from "@repo/shared/i18n";
import { useState } from "react";
import { useMediaQuery } from "usehooks-ts";

interface ResetEvolutionsDefaultPopupProps {
  data?: { onConfirm: () => void };
  onClose: () => void;
}

export const ResetEvolutionsDefaultPopup = ({
  data,
  onClose,
}: ResetEvolutionsDefaultPopupProps) => {
  const { t } = useTranslation(["evolutions", "common"]);
  const [doNotShowAgain, setDoNotShowAgain] = useState(false);
  const isMobile = useMediaQuery(BREAKPOINTS.MOBILE.query);
  if (!data?.onConfirm) {
    return null;
  }

  const handleConfirm = () => {
    if (doNotShowAgain) {
      localStorage.setItem(SKIP_RESET_EVOLUTIONS_DEFAULT_MODAL, "true");
    }
    data.onConfirm();
    onClose();
  };

  return (
    <BaseEvoPopup
      posLabel={t("common:reset")}
      onPositive={handleConfirm}
      handleOnClose={onClose}
      title={t("popups.resetDefault.title")}
      imageUrl={
        isMobile
          ? import.meta.env.VITE_APP_ASSETS_BASE_URL +
            `/${PINNED_ASSET_SLUG}/evolutions-hub/reset-include-exclude-mobile.png`
          : import.meta.env.VITE_APP_ASSETS_BASE_URL +
            `/${PINNED_ASSET_SLUG}/evolutions-hub/reset-includ-exclude-v2.png`
      }
    >
      <div className="flex flex-col gap-y-3">
        <p>
          <Trans
            ns="evolutions"
            i18nKey="popups.resetDefault.body"
            components={{
              b: <span className="font-semibold text-foreground" />,
            }}
          />
        </p>
        <p>{t("popups.resetDefault.note")}</p>
      </div>
      <div className="flex flex-col gap-y-4">
        <label className="flex items-center gap-2 cursor-pointer select-none text-sm text-foreground-body">
          <CheckBox
            checked={doNotShowAgain}
            onClick={() => setDoNotShowAgain((prev) => !prev)}
          />
          <span>{t("popups.doNotShowAgain")}</span>
        </label>
      </div>
    </BaseEvoPopup>
  );
};
